export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SolicitarPage.vue?vue&type=template&id=2262ba37&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/doctos-oficiales/SolicitarPage.vue?vue&type=template&id=2262ba37&scoped=true&
// module id = 569
// module chunks = 20